import { Routes } from '@angular/router';
import { AuthLayout2Component } from '@shared/components/layouts/auth-layout-2/auth-layout-2.component';
import { NavLayoutComponent } from '@shared/components/layouts/nav-layout/nav-layout/nav-layout.component';
import { UserIsLogedIn } from '@shared/guards/auth.guard';
import { NotFoundComponent } from '@views/not-found/not-found.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayout2Component,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'sessions',
      },
      {
        path: 'sessions',
        loadChildren: () => import('@views/sessions/sessions.routes').then(m => m.SessionsRoutes),
      },
    ],
  },
  {
    path: 'backoffice',
    component: NavLayoutComponent,
    canActivate: [UserIsLogedIn],
    children: [
      {
        path: '',
        loadChildren: () => import('@views/nav/nav.routes').then(m => m.NavRoutes),
      },
    ],
  },
  {
    path: '**',
    component: NotFoundComponent,
    title: 'Página no encontrada',
  },
];
